import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { initSentry } from './lib/sentry'
import { ErrorBoundary } from './components/ErrorBoundary'

// ORCA360 Frontend Entry Point
// Version: 2025-11-07 (Vector Embedding Fix + SOP Q&A Global Prompt)
// Initialize Sentry BEFORE React renders
// Only runs in production/staging, skipped in development
initSentry()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)


